import { AUTHFALSE, AUTHTRUE } from '../../redux/Types';
import { getLocalJson } from './utils';

const initialState = {
  authenticated: getLocalJson('authenticated'),
  token: localStorage.getItem('token'),
  expiryDate: localStorage.getItem('expiryDate'),
  // refreshToken: localStorage.getItem('refreshToken'),
  user: getLocalJson('user'),
};

const authReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case AUTHTRUE:
      return {
        ...state,
        authenticated: true,
        token: action.payload.token,
        expiryDate: action.payload.expiryDate,
        // refreshToken: action.payload.refreshToken,
        user: action.payload.user,
      };
    case AUTHFALSE:
      return {
        ...state,
        authenticated: false,
        token: null,
        expiryDate: null,
        // refresh: null,
        user: null,
      };
    default:
      return state;
  }
};

export default authReducer;
